module.exports = [{"title":"За все время"},{"id":"hours","title":"за 3 часа"},{"id":"day","title":"за день"},{"id":"week","title":"за неделю"},{"id":"month","title":"за месяц"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/periods.json
// module id = 1162
// module chunks = 49